import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdLock } from 'react-icons/io';
import { auth, signOut, signInWithEmailAndPassword } from 'config/firebase';
import axios from 'config/axios';
import Button from 'components/Button';
import TextInput from 'components/TextInput';
import { useAppDispatch } from 'hooks/useStore';
import { resetCart } from 'store/cart';
import { resetClassroom } from 'store/classroom';
import { setError, setAlert } from 'store/error';
import { expectOwnLoginChange } from 'config/sessionRevoked';
import './index.css';

// Shaped like an axios error so setAlert shows the message.
const RESIGN_IN_FAILED = {
    response: { data: { message: 'Your password was changed. Please sign in with your new password.' } }
};

function Account() {
    const [passwordChanged, setPasswordChanged] = useState(false);
    // const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const changePassword = (event) => {
        event.preventDefault();

        expectOwnLoginChange();
        axios.post('/students/password/', { newPassword })
            // Changing the password ends every session, this one included, so
            // sign straight back in with the new password.
            .then(() => signInWithEmailAndPassword(auth, auth.currentUser.email, newPassword)
                .catch(() => Promise.reject(RESIGN_IN_FAILED)))
            .then(() => {
                setNewPassword('');
                setPasswordChanged(true);
            })
            .catch(error => {
                console.log(error);
                dispatch(setAlert(error));
            });
    }

    const handleSignOut = () => {
        signOut(auth)
            .then(() => {
                // console.log('Signed out!');
                dispatch(resetCart());
                dispatch(resetClassroom());
                navigate('/');
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }

    return (
        <div className='account'>
            <div className='account__column'>
                <form className='account__form' onSubmit={changePassword}>
                    <p className='account__sectionHeader'>
                        <IoMdLock className='account__sectionHeaderIcon' />
                        Change your password
                    </p>
                    <TextInput
                        name='newPassword'
                        label='New password'
                        onChange={(event) => setNewPassword(event.target.value)}
                        type='password'
                        required
                        value={newPassword}
                    />
                    {passwordChanged
                        ?   <Button className='account__passwordChanged'>
                                PASSWORD CHANGED
                            </Button>
                        :   <Button
                                className='account__passwordChange'
                                secondary={newPassword.length < 6}
                                type='submit'
                            >
                                CHANGE PASSWORD
                            </Button>
                    }
                </form>
                <Button
                    className='account__signOut'
                    secondary
                    onClick={handleSignOut}
                >
                    SIGN OUT
                </Button>
            </div>
        </div>
    );
}

export default Account;